/* EQVA's own mark – the wordmark with the three waves. Two colourways: the official navy/blue on light
   surfaces and the all-white version on navy. Rasters derived from the hi-res brand file.
   Pass `height` for a fixed size (header); leave it out and size the <img> with CSS (footer). */
const SRC = {
  color: { webp: "/logos/eqva-logo-600.webp", png: "/logos/eqva-logo-600.png", webp2x: "/logos/eqva-logo-1200.webp" },
  white: { webp: "/logos/eqva-logo-white-600.webp", png: "/logos/eqva-logo-white-600.png", webp2x: "/logos/eqva-logo-white-1200.webp" },
};
const RATIO = 2481 / 1034;

export const BrandLogo = ({ variant = "color", height, className = "", alt = "EQVA", ...rest }) => {
  const s = SRC[variant] || SRC.color;
  const fixed = typeof height === "number" && height > 0;
  const w = fixed ? Math.round(height * RATIO) : 600;
  const h = fixed ? height : 250;
  return (
    <picture className={`block ${className}`} {...rest}>
      <source type="image/webp" srcSet={`${s.webp} 1x, ${s.webp2x} 2x`} />
      <img src={s.png} alt={alt} width={w} height={h} style={fixed ? { height, width: w } : undefined} className="block select-none" draggable="false" decoding="async" />
    </picture>
  );
};
